"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react/jsx-runtime"),a=require("styled-components"),s=require("@vds/typography"),i=require("@vds-tokens/core"),t=require("@plans/type-lockups"),o=require("@vds/utilities"),n=require("@plans/utilities"),r=require("@vds/tooltips");function l(e){return e&&e.__esModule?e:{default:e}}var c=l(a);const u=c.default.div.withConfig({displayName:"Wrapper",componentId:"VDS__sc-1qwcnzy-0"})`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: ${({justifyContent:e})=>e};
  white-space: nowrap;
  width: 100%;

  @media (max-width: ${n.breakpoints.mobileLarge.max}) {
    justify-content: space-between;
  }
`,d=c.default.div.withConfig({displayName:"PriceContainer",componentId:"VDS__sc-1qwcnzy-1"})`
  background-color: ${({surface:e})=>i.ColorTokens.background.secondary[e].value};
  border-radius: ${i.LayoutTokens.space["8X"].value};
  display: flex;
  flex-direction: ${({stacked:e})=>e?"column":"row"};
  margin-left: ${i.LayoutTokens.space["4X"].value};
`,p=c.default.div.withConfig({displayName:"PriceWrapper",componentId:"VDS__sc-1qwcnzy-2"})`
  padding: ${i.LayoutTokens.space["1X"].value} ${i.LayoutTokens.space["2X"].value}
    ${i.LayoutTokens.space["1X"].value} ${i.LayoutTokens.space["3X"].value};
  @media (min-width: ${n.breakpoints.tabletLarge.max}) {
    padding: ${i.LayoutTokens.space["2X"].value} ${i.LayoutTokens.space["2X"].value}
      ${i.LayoutTokens.space["2X"].value} ${i.LayoutTokens.space["4X"].value};
  }
`,y=c.default.div.withConfig({displayName:"EmptyPriceWrapper",componentId:"VDS__sc-1qwcnzy-3"})`
  padding: ${i.LayoutTokens.space["1X"].value} 0;
  text-align: center;
  width: 83px;
  @media (min-width: ${n.breakpoints.tabletLarge.max}) {
    width: 64px;
    padding: ${i.LayoutTokens.space["2X"].value} 0;
  }
`,m=c.default.div.withConfig({displayName:"SavingsWrapper",componentId:"VDS__sc-1qwcnzy-4"})`
  align-items: center;
  border-left: 1px solid
    ${({surface:e})=>i.ColorTokens.elements.lowcontrast[`on${e}`].value};
  display: flex;
  flex-direction: row;
  padding: ${i.LayoutTokens.space["1X"].value} ${i.LayoutTokens.space["3X"].value}
    ${i.LayoutTokens.space["1X"].value} ${i.LayoutTokens.space["2X"].value};
  @media (min-width: ${n.breakpoints.tabletLarge.max}) {
    padding: ${i.LayoutTokens.space["2X"].value} ${i.LayoutTokens.space["4X"].value}
      ${i.LayoutTokens.space["2X"].value} ${i.LayoutTokens.space["2X"].value};
  }
`;var g=o.withVDSManager((({title:a,price:o,savings:n,surface:l="light",viewport:c,justifyContent:g,tooltip:v})=>{const f="desktop"===c;return e.jsxs(u,Object.assign({justifyContent:g},{children:[!f&&e.jsx(s.Body,Object.assign({size:"large"},a,{color:i.ColorTokens.elements.primary[`on${l}`].value})),f&&e.jsx(s.Title,Object.assign({size:"small"},a,{color:i.ColorTokens.elements.primary[`on${l}`].value}))," ",e.jsxs(d,Object.assign({surface:l},{children:[o&&e.jsx(p,{children:e.jsx(t.Pricing,Object.assign({},o,{surface:l,uniformSize:!0,size:f?"medium":"small"}))}),!o&&e.jsx(y,{children:f?e.jsx(s.Title,Object.assign({size:"small"},{children:"—"})):e.jsx(s.Body,Object.assign({size:"large"},{children:"—"}))}),n&&e.jsxs(m,Object.assign({surface:l},{children:[e.jsx(t.Pricing,Object.assign({surface:l},n,{color:"green",uniformSize:!0,size:f?"medium":"small"})),v&&e.jsx(r.Tooltip,Object.assign({},v))]}))]}))]}))}));exports.default=g;
